export const ld = {
  bat: "Battery level",
  pul: "Pulse (Heart Rate)",
  pi: "Perfusion index",
  spo2: "Pulse oxygen",
  devid: "Device ID - MAC",
  model: "Model number",
  ihb: "Irregular heart beat",
  map: "Mean arterial pressure",
  dia: "Diastolic blood pressure",
  sys: "Systolic blood pressure",
  unum: "User Number (1 or 2)",
  kg: "Weight in KG",
  lb: "Weight in lbs",
  bmi: "Body mass index",
  mm: "Muscle mass",
  res: "Resistance",
  bw: "Body water",
  bfr: "Body fat rate",
  bm: "Basal metabolic",
  bms: "Bone mass",
  wr: "Water rate",
  mr: "Muscle rate",
  ffm: "Fat free weight",
  br: "Bone rate",
  bf: "Body fat",
  gluc: "Blood glucose level",
  unit: "Unit of measure",
  hilo: "Hi or Lo (out of range readings)",
  meal: "Meal tag (Before, After, Fasting)",
  tempc: "Temperature in celsius",
  tempf: "Temperature in fahrenheit",
  tempm: "Measurement mode (Head - Ear)",
};

export const new_format = {
  "Blood Pressure": {
    sys: "Systolic blood pressure",
    dia: "Diastolic blood pressure",
    pul: "Pulse(Heart Rate)",
    ihb: "Irregular heart beat",
    map: "Mean arterial pressure",
    unum: "User Number (1 or 2)",
  },
  "Pulse OX": {
    spo2: "Pulse oxygen",
    pul: "Pulse",
    pi: "Perfusion Index",
  },
  Scale: {
    lb: "Weight in lbs",
    kg: "Weight in kg",
    pul: "Pulse",
    bmi: "Body mass index",
    mm: "Muscle mass",
    res: "Impedance",
    bw: "Body Water",
    bfr: "Body fat rate",
    bms: "Bone mass",
    wr: "Water rate",
    mr: "Muscle rate",
    ffm: "Fat free weight",
    br: "Bone rate",
    bf: "Body fat",
    bm: "Basal metabolic",
  },
  Glucometer: {
    gluc: "Blood glucose level",
    unit: "Unit of measure",
    hilo: "Hi or Lo (out of range readings)",
    meal: "Meal tag (Before, After, Fasting)",
  },
  Thermometer: {
    tempc: "Temperature in celsius",
    tempf: "Temperature in fahrenheit",
    tempm: "Measurement mode (Head - Ear)",
  },
  "Activity Tracker": {
    awa: "Awake Time (minutes)",
    cal: "Calories",
    dsleep: "Deep Sleep Time(minutes)",
    dist: "Distance",
    Lspo2: "Last Pulse OX Measurement",
    Maxspo2: "Max Pulse OX Measurement",
    Minspo2: "Min Pulse OX Measurement",
    Lpul: "Last Pulse Measurement",
    Maxpul: "Max Pulse Measurement",
    Minpul: "Min Pulse Measurement",
    Lhrv: "Last hrv Measurement",
    Maxhrv: "Max hrv Measurement",
    Minhrv: "Min hrv Measurement",
    Ltemp: "Last body temperature",
    Maxtemp: "Max body temperature",
    Mintemp: "Min body temperature",
    lsleep: "Light Sleep Time(minutes)",
    step: "Step Count",
  },
  Fitness: {
    cal: "Calories",
    dist_M: "Distance(Meter)",
    dist_Mi: "Distance(Miles)",
    Lspo2: "Last Pulse OX Measurement",
    Maxspo2: "Max Pulse OX Measurement",
    Minspo2: "Min Pulse OX Measurement",
    Lpul: "Last Pulse Measurement",
    Maxpul: "Max Pulse Measurement",
    Minpul: "Min Pulse Measurement",
    Ltemp_C: "Last body temperature(Celsius)",
    Ltemp_F: "Last body temperature(Fahrenheit)",
    Maxtemp_C: "Max body temperature(Celsius)",
    Maxtemp_F: "Max body temperature(Fahrenheit)",
    Mintemp_C: "Min body temperature(Celsius)",
    Mintemp_F: "Min body temperature(Fahrenheit)",
    lsleep: "Light Sleep Time(minutes)",
    dsleep: "Deep Sleep Time(minutes)",
    awa: "Awake Time (minutes)",
    step: "Step Count",
    Lstress: "Latest Stress",
    Minstress: "Min Stress",
    Maxstress: "Max Stress",
  },
};

export const cellular_device = {
  "Blood Pressure": {
    sys: "Systolic blood pressure",
    dia: "Diastolic blood pressure",
    pul: "Pulse (Heart Rate)",
    ihb: "Irregular heart beat",
    unum: "User ID",
  },
  Scale: {
    kg: "Weight in kg",
    lb: "Weight in Lbs",
  },
  Glucometer: {
    gluc: "Blood glucose level",
    meal: "Meal tag (Before, After, Fasting)",
    sample: "Sample",
    target: "Target",
    unit: "Unit",
  },
  "Pulse OX": {
    spo2: "Pulse oxygen",
    pul: "Pulse",
    pi: "Perfusion Index",
  },
};
